// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Spacer_spacer__Es1Gp","xsm":"Spacer_xsm__Y9XdU","sm":"Spacer_sm__1FWNY","md":"Spacer_md__1FsGo","lg":"Spacer_lg__2uSGt","xlg":"Spacer_xlg__3F6z1"};